import { Button, Space, TableProps } from "antd";
import SortIcon from "../../../assets/icons/SortIcon";
import { useGetSelectedEmployeesQuery } from "../../../features/attendanceSetting/attendanceSettingApi";
import useError from "../../../hooks/useError";
import useTable from "../../../hooks/useTable";
import { ModalComponentProps } from "../../../types";
import {
  GetSelectedEmployeesResponseType,
  ViewSelectedUserParams,
} from "../../../types/attendance";
import { addKeyInArray } from "../../../utils/utils";
import CustomModal from "../../ui/CustomModal";
import CustomTable from "../../ui/CustomTable";

export default function ViewSelectedUserModal({
  data,
  savedData,
  handleClose,
  ...rest
}: ModalComponentProps<ViewSelectedUserParams["type"]> & {
  savedData?: GetSelectedEmployeesResponseType["data"];
}) {
  const { page, limit, handlePagination, handleLimit, filter } =
    useTable<ViewSelectedUserParams>({
      defaultFilter: {
        type: data!,
      },
    });

  const {
    isLoading,
    isError,
    error,
    data: getData,
  } = useGetSelectedEmployeesQuery({
    params: {
      ...filter,
    },
  }, { skip: !!savedData });

  useError(isError, error, "Get employee data fail");

  const columns: TableProps<
    GetSelectedEmployeesResponseType["data"]["members"][0]
  >["columns"] = [
    {
      title: "Employee Id",
      dataIndex: "employee_id",
      sorter: (a, b) =>
        Number(a?.employee_id ?? 0) - Number(b?.employee_id ?? 0),
      sortIcon: () => <SortIcon />,
      render: (val) => (
        <span className="flex items-center gap-1.5">{val ?? "n/a"}</span>
      ),
    },
    {
      title: "Employee Name",
      dataIndex: "name",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      sortIcon: () => <SortIcon />,
      render: (val, record) =>
        val ? (
          <div className="min-w-32 flex items-center gap-1.5">
            {record?.pro_pic ? (
              <img
                className="w-8 h-8 rounded-full"
                src={record?.pro_pic}
                alt=""
              />
            ) : null}
            {val}
          </div>
        ) : (
          "n/a"
        ),
    },
    {
      title: "Email ID",
      dataIndex: "email",
      sorter: (a, b) => a?.email?.localeCompare(b?.email),
      sortIcon: () => <SortIcon />,
      render: (val) => val ?? "n/a",
    },
    {
      title: "Department",
      dataIndex: "department_name",
      sorter: (a, b) => a?.department_name?.localeCompare(b?.department_name),
      sortIcon: () => <SortIcon />,
      render: (val) => val ?? "n/a",
    },
  ];

  return (
    <CustomModal
      footer={null}
      closeIcon={null}
      width={800}
      className="modal-padding-hide"
      handleClose={handleClose}
      {...rest}
    >
      <CustomTable
        loading={isLoading}
        limit={limit}
        page={page}
        columns={columns}
        total={savedData?.total ?? getData?.data?.total}
        dataSource={addKeyInArray(savedData
          ? savedData.members.slice((page - 1) * limit, page * limit)
          : getData?.data?.members)}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        topSectionClassName="sticky top-0 z-10 bg-white"
      />

      <Space className="w-full p-4 sticky bottom-0 bg-white" size={12}>
        <Button
          className="normal-dark-button modal-button"
          onClick={handleClose}
          size="middle"
        >
          Cancel
        </Button>
      </Space>
    </CustomModal>
  );
}
